/* 3 fonts installed from Npm
 *  Example of usage
 *  heading: `'Open Sans', sans-serif`
 *  p: `'Raleway', sans-serif`,
 *
 */
const fonts = {
    heading: `'Lato'`,
    body: `'Lato'`
}
export default fonts
